//Button pour accéder au panneau de gestion de la boutique

import { useLocation, useNavigate } from "react-router";
import useGraphUserData from "../../lib/hooks/useGraphUserData";

import IconTextButton from "../Button/IconTextButton";

import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import HomeIcon from "@mui/icons-material/Home";

export default function GestionButton() {
	const navigate = useNavigate();
	const location = useLocation().pathname;
	const { userData } = useGraphUserData();

	if (
		userData &&
		(userData.id === "amoisant" || userData.id === "srimasson")
	) {
		return location.includes("gestion") ? (
			<IconTextButton
				color="info"
				size="Large"
				icon={<HomeIcon />}
				onClick={() => navigate("./")}
			>
				Acceuil
			</IconTextButton>
		) : (
			<IconTextButton
				color="info"
				size="Large"
				icon={<DisplaySettingsIcon />}
				onClick={() => navigate("./gestion")}
			>
				Gestion
			</IconTextButton>
		);
	}
	return null;
}
